<script>
import { mapGetters, mapActions } from 'vuex';
import stripeSetts from "@/settings/stripe";

export default {
  data() {
    return {
      stripeInited: false
    };
  },
  created() {
    this.getProvider()
      .then(res => {
        this.connectToStripe();
      });
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  },
  methods: {
    ...mapActions({
      getProvider: 'getProvider'
    }),
    connectToStripe() {
      if (window.Stripe) 
        return false;

      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v2/";
      script.id = "stripeScript";
      script.onload = () => this.initStripe();
      document.body.appendChild(script);
    },
    initStripe(key) {
      if (!key)
        key = this.provider.stripe_id || this.provider.stripe_public_key;

      if (!key/* || !window.Stripe*/)
        return;
        
      Stripe.setPublishableKey(key);
      this.stripeInited = true;
    },
    handlerSubmitNew() {
      if (!window.Stripe) 
        return false;

      const data = {
        number: this.card.number,
        cvc: this.card.cvc,
        exp_month: this.card.expiration.month,
        exp_year: this.card.expiration.year,
        name: this.address.name,
        address_line1: this.address.street,
        address_city: this.address.city,
        address_country: this.address.country ? this.address.country.code : null,
        address_state: this.address.state ? this.address.state.code : null,
        address_zip: this.address.zip
      };
      Stripe.createToken(data, this.stripeTokenHandler);
    },
  },
  watch: {
    provider(val) {
      if (!this.stripeInited && val && window.Stripe) 
        this.initStripe();
    }
  }
}
</script>